<template>
  <div class="header" :class="{ 'search-result-page': isSearch,'header-page': isIndex }">
    <div class="t-top">
      <div class="wp" :class="{'caseSearch' : isSearch}">
        <!-- hd-top -->
        <div class="hd-top fix">
          <div class="logo" v-if="!isSearch">
            <a href="index.html">
              <img class="logo1" src="static/images/logo.png" alt />
              <img class="logo2" src="static/images/logo_2.png" alt />
            </a>
          </div>
          <div class="logoSearch" v-else>
            <a href="index.html">
              <img class="logo1" src="static/images/logo.png" alt />
              <img class="logo2" src="static/images/logo_2.png" alt />
            </a>
          </div>
          <span @click="openNav" :class="['menuBtn',{'open': isOpen}]"></span>
          <!-- hd-rightBtn -->
          <div v-if="!logined" class="hd-rightBtn">
            <a href="javascript:void(0)" class="login" @click="login()">登录</a>
            <a>/</a>
            <a href="regist.html" class="sign">注册</a>
          </div>
          <div v-if="logined" class="hd-rightBtnNo">
            <a href="personal.html" :title="userName" class="username" target="_blank">{{userName}}</a>
            <a href="javascript:void(0)" class="logout" @click="logout('self_exit')">退出</a>
          </div>
          <!-- hd-rightBtn end -->
          <!-- nav -->
          <div :class="['nav',{'open': isOpen}]">
            <ul class="ul-nav fix">
              <li :class="{'on': tab === 1}">
                <a href="index.html" class="v1">首页</a>
              </li>
            </ul>
          </div>
          <!-- nav end -->
        </div>
        <!-- hd-top end -->
      </div>
    </div>
    <div class="wp">
      <div class="hd-search">
        <div class="tit">
          <img src="static/images/search-logo.png" alt />
        </div>
        <div class="search">
          <div class="inp">
            <input type="text" class="text" placeholder="请输入搜索词" v-model="q" @keyup.enter="query" />
          </div>
          <div class="submit">
            <input type="submit" placeholder="搜索" @click="query" value="搜索" />
          </div>
        </div>
      </div>
      <messageDialog :errorMessage="message" :show="messageShow" v-show="messageShow" @showModal="getMsg"></messageDialog>
    </div>
    <div class="theme-cards-container" v-if="isIndex">
      <div class="theme-card" @click="tabHandler(2)" @mouseenter="cardHoverEffect($event, true)" @mouseleave="cardHoverEffect($event, false)">
        <div class="card-content">
          <div class="card-title">2023年全国高质量临床教学案例结果公布</div>
          <div class="card-icon">
            <i class="card-arrow"></i>
          </div>
        </div>
      </div>
      <div class="theme-card" @click="tabHandler(3)" style="display:none" @mouseenter="cardHoverEffect($event, true)" @mouseleave="cardHoverEffect($event, false)">
        <div class="card-content">
          <div class="card-title">2023年全国高质量临床教学案例展示</div>
          <div class="card-icon">
            <i class="card-arrow"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="wp" v-if="isIndex">
      <div class="system-list" style="padding-left: 10%;">
        <span class="system-item" v-for="item in systems" :key="item.innerCode" @click="toSystemList(item.innerCode)"><span>{{item.name}}</span></span>
      </div>
      <messageDialog :errorMessage="message" :show="messageShow" v-show="messageShow" @showModal="getMsg"></messageDialog>
    </div>
    <ie-tips/>
  </div>
  <!-- 头部 end -->
</template>

<script>
import ieTips from "../components/ieTips.vue"
import messageDialog from '../components/messageDialog'
import priv from '../../utils/priv.js'
import util from '../../utils/util'
import axios from 'axios'

export default {
  props: {
    // 设置免登录访问 true 为免登录
    noLogin: {
      type: Boolean,
      default: false
    },
    isSearch: {
      type: Boolean,
      default: false
    },
    searchKey: {
      type: String,
      default: ''
    },
    tab: {
      type: Number,
      default: 1
    }
  },
  name: 'mHeader',
  data: () => {
    return {
      custom: {},
      isOpen: false,
      messageCount: 0,
      q: '',
      message: '',
      messageShow: false,
      logined: false,
      userName: '',
      zasServerUrl: '',
      systems: [],
      isIndex: false
    }
  },
  watch: {
    searchKey(a, o) {
      this.q = this.searchKey ? this.searchKey : ''
    },
    logined(value) {
      this.$emit('isLogin', value)
    }
  },
  components: {
    messageDialog,
    ieTips
  },
  async created() {
    let pathname = location.pathname.replace(/\/\//g,'/')
    if ( pathname === '/' || pathname === '/index.html' || pathname === '/cbl/index.html' || pathname === '/cbl/'){
      this.isIndex = true
    }
    this.isLogin()
    let result = await priv.checkButtonPriv()
    this.custom = Object.assign({}, result)
    this.initSystems()
  },
  methods: {
    async initSystems() {
      let resp = await this.axios.get('/front/classtype/xk/classify').then(res => res.data.data)
      this.systems = resp
    },
    async isOnline(logined) {
      let referer = localStorage.getItem('Referer')
        ? localStorage.getItem('Referer')
        : location.href
      let configs = await this.axios.get('/front/member/login/config?Referer=' + encodeURIComponent(referer)).then(res => res.data.data)
      let zasServerUrl = configs ? configs.zasServerUrl : ''
      let zasClientId = configs ? configs.clientID : ''
      let data = {
        Validate: getInfo(),
        client_id: zasClientId
      }
      axios.post(zasServerUrl + 'zapiv3/browser/login/onlineValidata?' + new Date(), data, { withCredentials: true }).then(res => {
        res = res.data
        if (res.success) {
          if (!logined) {
            localStorage.setItem('Referer', location.href)
            window.location.href = './login.html'
          }
        } else {
          if (logined) {
            this.logout('self_exit')
          }
        }
      })
    },
    async isLogin() {
      let resp = await this.axios
        .get('/front/member/login/username')
        .then(resp => resp.data)
      if (resp.status === 1) {
        this.logined = true
        this.userName = resp.data.username
        if (!resp.data.backgroundLogin){
          this.isOnline(true)
        } 
      } else {
        this.isOnline(false)
      }
    },
    openNav() {
      this.isOpen = !this.isOpen
    },
    hasPriv(k) {
      if (this.custom.keys) {
        return this.custom.keys[k] === 1
      }
      return false
    },
    async tabHandler(val) {
      if (2 === val) {
        let _this = this
        let result = await priv.checkButtonPriv()
        if (result && result.index && result.index.msg && result.index.redirecturl) {
          util.showInfoMessage(result.index.msg)
          return
        }
        window.location.href ='./selected.html'
      } else if (3 === val) {
        window.location.href ='./case.html'
      }
    },
    cardHoverEffect(event, isEnter) {
      const card = event.currentTarget;
      if (isEnter) {
        card.classList.add('card-hover');
      } else {
        card.classList.remove('card-hover');
      }
    },
    login() {
      localStorage.setItem('Referer', location.href)
      window.location.href = 'login.html'
    },
    async logout(action) {
      let referer = localStorage.getItem('Referer') ? localStorage.getItem('Referer') : location.href
      let configs = await this.axios
      .get(
        '/front/member/login/config?Referer=' + encodeURIComponent(referer)
      )
      .then(res => res.data.data)
      let zasClientId = configs ? configs.clientID : ''
      let zasServerUrl = configs ? configs.zasServerUrl : ''
      let data = {
        Validate: getInfo(),
        client_id: zasClientId
      }
      axios.post(zasServerUrl + 'zapiv3/browser/login/logout?' + new Date().getTime(), data, { withCredentials: true }).then(res => {
        this.reload(referer, action)
      })
    },
    async reload(referer, action){
      let configs = await this.axios
        .get('/front/member/logout?Referer=' + encodeURIComponent(referer) + '&action=' + action)
        .then(res => res.data.data)
        if ('self_exit' === action){
          let zasLogout = configs ? configs.ssologout : ''
          // window.location.href = zasLogout
          window.location.href = 'index.html'
        }
    },
    toSystemList(innercode) {
      window.location.href = `./search.html?system=${innercode}`
    },
    async query() {
      if (this.q !== '' && this.q.trim() !== '') {
        if (this.q.match(/[$#&<>]/)){
          util.showInfoMessage('请勿在搜索条件中输入特殊符号$、#、&、<、>')
          return
        }
        window.location.href = `./search.html?q=${encodeURIComponent(encodeURIComponent(this.q))}`
      }else {
        window.location.href = `./search.html`
      }
    },
    getMsg(data) {
      this.messageShow = data
    }
  }
}
</script>
<style scoped>
.theme-cards-container {
  margin: 0 auto;
  max-width: 490px;
  width: 75%;
  display: flex;
  justify-content: space-between;
  gap: 30px;
  padding: 25px 0;
}

.theme-card {
  flex: 1;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  position: relative;
  min-height: 110px;
  display: flex;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.theme-card::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #4285f4, #34a853, #fbbc05, #ea4335);
  transition: height 0.3s ease;
}

.theme-card:hover, .theme-card.card-hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
}

.theme-card:hover::after, .theme-card.card-hover::after {
  height: 6px;
}

.theme-card:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, rgba(247, 249, 255, 0.8), rgba(255, 255, 255, 0));
  opacity: 0;
  transition: opacity 0.4s ease;
}

.theme-card:hover:before, .theme-card.card-hover:before {
  opacity: 1;
}

.card-content {
  padding: 22px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 1;
}

.card-title {
  color: #333333;
  font-size: 18px;
  font-weight: bold;
  line-height: 1.5;
  flex: 1;
  text-align: left;
}

.card-icon {
  margin-left: 18px;
  background-color: rgba(66, 133, 244, 0.1);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  position: relative;
}

.theme-card:hover .card-icon, .theme-card.card-hover .card-icon {
  background-color: rgba(66, 133, 244, 0.2);
  transform: scale(1.1);
}

.card-arrow {
  display: block;
  width: 8px;
  height: 8px;
  border-top: 2px solid #4285f4;
  border-right: 2px solid #4285f4;
  transform: rotate(45deg);
  transition: all 0.3s ease;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -5px 0 0 -4px;
}

.theme-card:hover .card-arrow, .theme-card.card-hover .card-arrow {
  transform: rotate(45deg) translateX(2px);
  border-color: #1a73e8;
  border-width: 2px;
}

@media only screen and (max-width: 767px) {
  .theme-cards-container {
    flex-direction: column;
    gap: 20px;
    padding: 20px 0;
  }
  
  .theme-card {
    margin-bottom: 0;
    min-height: 90px;
  }
  
  .card-content {
    padding: 18px;
  }
  
  .card-title {
    font-size: 16px;
  }
  
  .card-icon {
    width: 30px;
    height: 30px;
  }
}
.system-item {
  width: 25%;
  display: inline-block;
  cursor: pointer;
  color: #fff;
  margin-top: 30px;
  text-align: left;

}
.system-item span{
  border-bottom:1px solid #FFF;
  padding-bottom: 5px;
}
.system-item span:hover{
  border-bottom:1px solid #1ad5b1;
  color:#1ad5b1;
  font-weight: bold;
}
ol,
ul {
  margin: 0;
  padding: 0;
}
.t-top {
  border-bottom: 1px solid #9db4e1;
}
.hd-top {
  padding-top: 5px;
  margin-bottom: 0;
}
.hd-search {
  margin-top: 50px;
  margin-bottom: 20px;
}
a:hover {
  color: #ffffff;
  text-decoration: none;
}
.hd-search .search .select {
  width: 85px;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  text-align: center;
  background: #f9f9f9;
  color: #83838f;
  font-size: 16px;
}
.case {
  background: #1ad5b1 !important;
  margin-right: 30px;
  padding: 0 7px;
  /* margin-right:50px */
}
.logoSearch{
  width: 378px;
  display: flex;
  align-items: center;
  float: left;
}
.logoSearch .logo1 {
  height: 120%;
  width: 105px;
  display: inline;
}
.logoSearch .logo2 {
  height: auto;
  width: 250px;
  display: inline;
}
.caseSearch {
  max-width: 1200px;
}
@media only screen and (max-width: 767px) {
  .logoSearch{width: 168px;}
  .logoSearch img {height: 20px;width: auto;}
  
}
@media only screen and (max-width: 321px) {
  .hd-rightBtnNo .username {
    width: 60px;
    margin-left: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/mHeader.vue